import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import Loader from './loader'
import ReactGA from 'react-ga';
import config from 'config'


@inject('store')
@observer
class ContactForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            email: '',
            name: '',
            mobile_number: '',
            errors: '',
            message: '',
            loader: false,
            success: false,
            emailvalidation: '',
        }
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        this.initializeReactGA()
        this.props.store.homeType(true)
    }


    initializeReactGA() {
        ReactGA.initialize('UA-128486561-1');
        ReactGA.pageview('/homepage');
    }

    handleValidation() {
        let formdatas = this.state
        let errors = {};
        let formIsValid = true;

        if (!formdatas["name"]) {
            formIsValid = false;
            errors["name"] = "Name is require";
        }

        if (formdatas['email'] == '') {
            var numbers = /^[0-9]+$/;
            if (!formdatas["mobile_number"].match(numbers)) {
                formIsValid = false;
                errors["mobile_number"] = "Mobile Number Not a Valid Number"
            }

            if (formdatas["mobile_number"].length != 10) {
                formIsValid = false;
                errors["mobile_number"] = "Mobile Number Must have 10 digit"
            }

            if (!formdatas["mobile_number"]) {
                formIsValid = false;
                errors["mobile_number"] = "Mobile Number is required";
            }
        } else {
            if (!formdatas["email"]) {
                formIsValid = false;
                errors["email"] = "Cannot be empty";
            }

            if (typeof formdatas["email"] !== "undefined") {
                let lastAtPos = formdatas["email"].lastIndexOf('@');
                let lastDotPos = formdatas["email"].lastIndexOf('.');

                if (!(lastAtPos < lastDotPos && lastAtPos > 0 && formdatas["email"].indexOf('@@') == -1 && lastDotPos > 2 && (formdatas["email"].length - lastDotPos) > 2)) {
                    formIsValid = false;
                    errors["email"] = "Email is not valid";
                }
            }
        }

        if (!formdatas["message"]) {
            formIsValid = false;
            errors["message"] = "Message is require";
        }

        if (formdatas["message"].length > 1000) {
            formIsValid = false;
            errors["message"] = "Message exceeded character limit"
        }
        this.setState({errors: errors});
        return formIsValid;
    }

    onchangevalue(e) {
        let value = this.state;
        value[e.target.name] = e.target.value;
        this.setState(value)
    }

    contactUs(e) {
        e.preventDefault()
        if (this.handleValidation()) {
            this.setState({loader: true})
            var form = JSON.stringify({
                email: this.state.email,
                name: this.state.name,
                message: this.state.message,
                phone: this.state.mobile_number
            })
            console.log(form)
            fetch(`${config.REV_URL}/contactus`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: form
            })
                .then(response => response.json())
                .then(res => {
                    this.setState({loader: false});
                    console.log(res)
                    if (res.message == 'Thank you') {
                        this.setState({name: '', email: '', message: '', success: true, emailvalidation: ''});
                        setTimeout(() => {
                            this.setState({success: false})
                        }, 3000)
                    } else if (res.error == true) {
                        this.setState({emailvalidation: res.message})
                    }

                }).catch((err) => {
                console.log(err)
            })
        }
    }

    render() {
        return (
            <section className="getIntouches-contact-us full-w" id="contactus">
                <div className="container" data-aos="fade-up">
                    <div className="row">
                        <div className="col-lg-5 col-md-5 col-sm-6 col-xs-12">
                            <b className="heading_tow">GET IN TOUCH</b><br/>
                            <p className="fz-13 mgt-10 textrescenter">Get in touch with us if you have any queries</p>
                            <b className="heading_tow" style={{fontSize:'30px'}}>CUSTOMER GRIEVANCE REDRESSAL</b><br/>
                            {/* <b className="heading_tow">CUSTOMER GRIEVANCE REDRESSAL</b> */}
                            {/* <h3 className="fz-20 mt-3">CUSTOMER GRIEVANCE REDRESSAL</h3> */}
                            <ul className="mgt-10" style={{ fontSize: "14px" }}>
                                    <li>Our dedicated customer service team is here to assist you with any concerns or queries you may have. You can reach them via email at <a href="care@revfin.in">care@revfin.in</a>  or by calling +918686738738.
                                        If the initial resolution doesn't meet your expectations, our Grievance Redressal Officer is available to address escalated matters. The details are below:</li>
                                    <div style={{ marginLeft: "30px" }}>
                                        <li style={{ listStyleType: "square" }}>Ms. Payal Maini - Head of Operations</li>
                                        <li style={{ listStyleType: "square" }}>Address: Revfin, 2nd Floor, E-Block, International Trade Tower, Nehru Place, New Delhi-110019</li>
                                        <li style={{ listStyleType: "square" }}>Contact: +91 8882974667</li>
                                        <li style={{ listStyleType: "square" }}>Email: <a href="ngo@revfin.in">ngo@revfin.in</a></li>
                                    </div>
                                </ul>
                        </div>
                        <div className="col-lg-7 col-md-7 col-sm-6 col-xs-12 relative">
                            <div className={`successfullymessage ${this.state.success ? 'showmessage' : ''}`}>Sent
                                successfully
                            </div>
                            <form className="form-inline errohandle" onSubmit={this.contactUs.bind(this)}>
                                <div className="full-w">
                                    <input type="text" className="mb-2 mr-sm-2 textwidth" name="name" placeholder="Name"
                                           value={this.state.name}
                                           onChange={this.onchangevalue.bind(this)}
                                    />
                                    <div className="full-w error">{this.state.errors["name"]}</div>
                                </div>
                                <div className="full-w myflex f-between form-group">
                                    <div className="half-w">
                                        <input type="tel" className="mb-2 mr-sm-2 textwidth" name="mobile_number"
                                               placeholder="Mobile Number" maxLength="10"
                                               value={this.state.mobile_number}
                                               onChange={this.onchangevalue.bind(this)}
                                        />
                                        <div className="full-w error">{this.state.errors["mobile_number"]}</div>
                                    </div>
                                    <div className="half-w">
                                        <input type="text" className="mb-2 mr-sm-2 textwidth" name="email"
                                               placeholder="Email ID"
                                               value={this.state.email}
                                               onChange={this.onchangevalue.bind(this)}
                                        />
                                        <div className="full-w error">{this.state.errors["email"]}</div>
                                    </div>
                                </div>
                                <div className="full-w">
                                    <textarea className="full-w textwidth" rows="5" name="message"
                                              placeholder="Your Message"
                                              value={this.state.message}
                                              onChange={this.onchangevalue.bind(this)}
                                    ></textarea>
                                    <div className="the-count">
                                        <span className={`banner ${this.state.message.length<=1000 ? "current" : "char-exceeded"}`}>{this.state.message.length}</span>
                                        <span className="maximum">/ 1000</span>
                                    </div>
                                    <div className="full-w error">{this.state.errors["message"]}</div>
                                </div>
                                <div className="full-w myflex f-between flex-center">
                                    <button type="submit" className="btn submitbutton mb-2">Submit</button>
                                    {this.state.loader ? <Loader/> : ''}
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default ContactForm



// WEBPACK FOOTER //
// ./src/components/ContactForm.js